import L from 'leaflet';

import { 
    POINT_ICON_CONFIG,
    getPointIconConfigByZoom 
} from './constants';

function capitalizeWords(value = '') {

    return String(value)
        .toLocaleLowerCase('pt-BR')
        .replace(
            /(^|\s)(\p{L})/gu,
            (_, prefix, letter) =>
                prefix +
                letter.toLocaleUpperCase('pt-BR')
        );
}

export function createPointIcon(
    type = 'point',
    {
        label = null,
        zoom = null
    } = {}
) {

    let config =
        POINT_ICON_CONFIG[type] ??
        POINT_ICON_CONFIG.point;

    if (zoom != null) {

        config = {
            ...config,
            ...getPointIconConfigByZoom(
                zoom
            )
        };
    }

    const formattedLabel =
        label
            ? capitalizeWords(label)
            : null;

    const transparent = config.transparent === true;

    return L.divIcon({

        html: `
            <div
                style="
                    position:relative;
                    width:${config.size}px;
                    height:${config.size}px;
                    border-radius:50%;
                    background:${transparent ? 'transparent' : 'white'};
                    border:${transparent
                        ? 'none'
                        : `${config.borderSize ?? 2}px solid ${config.color}`};
                    box-shadow:${transparent ? 'none' : '0 0 6px rgba(0,0,0,.45)'};
                    color:${config.color};
                "
            >
                <span
                    style="
                        position:absolute;
                        left:50%;
                        top:50%;
                        transform:translate(
                            calc(-50% + ${config.offsetX ?? 0}px),
                            calc(-50% + ${config.offsetY ?? 0}px)
                        );
                        font-size:${config.fontSize}px;
                        font-weight:bold;
                        line-height:1;
                    "
                >
                    ${config.symbol ?? ''}
                </span>

                ${formattedLabel ? `
                    <span
                        class="map-point-label"
                        style="
                            font-size:${config.labelFontSize}px;
                        "
                    >
                        ${formattedLabel}
                    </span>
                ` : ''}
            </div>
        `,

        iconSize: [
            config.size,
            config.size
        ],

        iconAnchor: [
            config.size / 2,
            config.size / 2
        ],

        className: ''
    });
}